import { INVOICE_GROUPING_TYPES } from './InvoiceGroupingTypes';

export const AWAITING_BILLABLE_EVENT = 'awaiting_billable_event';
export const INCOMPLETE = 'incomplete';
export const READY_TO_BILL = 'ready_to_bill';
export const AUDITED = 'audited';
export const INVOICED = 'invoiced';
export const SUPPLEMENTAL_INVOICE = 'supplemental_invoice';
export const TEMPLATE_BILLING = 'template_billing';
export const CUSTOMER_PORTAL = 'customer_portal';
export const BILLING_HOLD = 'billing_hold';
export const PENDING_REVIEW = 'pending_review';

export default {
  AWAITING_BILLABLE_EVENT,
  INCOMPLETE,
  READY_TO_BILL,
  AUDITED,
  INVOICED,
  SUPPLEMENTAL_INVOICE,
  TEMPLATE_BILLING,
  CUSTOMER_PORTAL,
  BILLING_HOLD,
  PENDING_REVIEW,
};

export const billingStatusList = [
  AWAITING_BILLABLE_EVENT,
  INCOMPLETE,
  READY_TO_BILL,
  AUDITED,
  INVOICED,
  SUPPLEMENTAL_INVOICE,
  TEMPLATE_BILLING,
  CUSTOMER_PORTAL,
  BILLING_HOLD,
  PENDING_REVIEW,
].sort();

export const FULL_CONTAINER_DELIVERED = 'FULL_CONTAINER_DELIVERED';
export const EMPTY_CONTAINER_RETURNED = 'EMPTY_CONTAINER_RETURNED';
export const FULL_CONTAINER_PICKED_UP_LOADED =
  'FULL_CONTAINER_PICKED_UP_LOADED';
export const PICKUP_LOADED_OR_EMPTY = 'PICKUP_LOADED_OR_EMPTY';
export const DELIVERY_LOADED_OR_EMPTY = 'DELIVERY_LOADED_OR_EMPTY';

export const billableEventList = [
  FULL_CONTAINER_DELIVERED,
  EMPTY_CONTAINER_RETURNED,
  FULL_CONTAINER_PICKED_UP_LOADED,
  PICKUP_LOADED_OR_EMPTY,
  DELIVERY_LOADED_OR_EMPTY,
].sort();

export const invoiceGroupingFilterList = Object.values(
  INVOICE_GROUPING_TYPES,
).sort();
